import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import type { SubscriptionInfo } from '../api/subscription/model';
import { subscriptionApi } from '../api';
import { SUBSCRIPTION_INFO_QUERY_KEY, SUBSCRIPTION_QUERY_CONFIG } from './config';

type UseSubscriptionInfoOptions = Pick<UseQueryOptions, 'enabled'>;

export const useSubscriptionInfo = (
  options?: UseSubscriptionInfoOptions,
): UseQueryResult<SubscriptionInfo> => {
  return useQuery(SUBSCRIPTION_INFO_QUERY_KEY, subscriptionApi.getSubscriptionInfo, {
    ...SUBSCRIPTION_QUERY_CONFIG,
    enabled: options?.enabled ?? true,
  });
};
